import { render, staticRenderFns } from "./CreateSurveyQuestions.vue?vue&type=template&id=fc6b16a2&scoped=true&"
import script from "./CreateSurveyQuestions.vue?vue&type=script&lang=ts&"
export * from "./CreateSurveyQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSurveyQuestions.vue?vue&type=style&index=0&id=fc6b16a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6b16a2",
  null
  
)

export default component.exports